import React ,{useEffect, useState, useMemo, useCallback , Fragment} from 'react';
import Breadcrumb from '../../components/common/breadcrumb';
import DataTable from 'react-data-table-component'
import { useDispatch, useSelector } from 'react-redux'
import { watchyoutubevideosfunc } from '../../redux/videos/action'
import Moment from 'moment'
import { Unpublish, Publish , ListVideos } from '../../constant'
import SweetAlert from 'sweetalert2'
import { ApiCall } from '../../api';
import { useNavigate } from 'react-router-dom'

const GetVideos = () => {
    const navigate = useNavigate();
    const col = [
        {
          name: 'Video Id',
          selector: (row) => row.youtube_id,
          sortable: true,
          center: true,
        },
        {
          name: 'Channel Title',
          selector: (row) => row.channelTitle,
          sortable: true,
          center: true,
        },
        {
            name: 'Title',
            selector: (row) => row.title,
            sortable: true,
            center: true,
        },
        {
            name: 'Views',
            selector: (row) => row.viewCount,
            sortable: true,
            center: true,
        },
        {
            name: 'Likes',
            selector: (row) => row.likeCount,
            sortable: true,
            center: true,
        },
        {
          name: 'Published On',
          selector: (row) => row.publishedAt !== '' ? Moment(row.publishedAt).format('DD-MM-YYYY') : '-',
          sortable: true,
          center: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status === 0 ? <span className="badge badge-danger">{Unpublish}</span> : <span className="badge badge-success">{Publish}</span>,
            sortable: true,
            center: true,
        },
        {
            name: 'Action',
            selector: (row) =>  <Fragment><div onClick={()=>handleClick(row.status, row._id)}> <span><i className="fa fa-refresh" style={{ width: 35, cursor:'pointer', fontSize: 16, padding: 11, color: 'rgb(40, 167, 69)' }}></i></span></div></Fragment>,
            sortable: true,
            center: true,
        },
    ];
    const dispatch = useDispatch();
    const [load, setLoad] = useState(false);
    const myselector = useSelector((state) => state.Video);
    const authSelector = useSelector((state) => state.Auth.authData);

    const [data, setData] = useState({
        columns: col,
        data: [],
    });   
    const [formData, setFormData] = useState({
        "page": 1,
    })

    useEffect(() => {
        dispatch(watchyoutubevideosfunc(formData))
    },[formData])

    useEffect(() => {
        setData((pre) => {
            return {
                columns: pre.columns,
                data: myselector.videoList,
            };
        });
        setLoad(myselector.loadVideos)
    },[myselector])

    const handleClick = (status, id) =>{
        let message;
        let errormsg;
        if(status ===0) {
            message = "You want to publish video on website!"
            errormsg = 'Your video is not published on website!'
        }else{
            message = "You want to unpublish video from website!"
            errormsg = 'Your video is on website!'
        }
        SweetAlert.fire({
            title: 'Are you sure?',
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                const updateData = {
                    "id": id,
                    "status": status === 0 ? 1 : 0  
                }
                ApiCall(updateData, "POST", "update_video_status", authSelector.token, handleResponse)
            }
            else{
                SweetAlert.fire(errormsg)
            }
        })
    }

    const handleResponse = useCallback((response) => {
        if(response.status){
            SweetAlert.fire(response.message, 'success')
            dispatch(watchyoutubevideosfunc(formData))
        }else{
            SweetAlert.fire(response.message)
            dispatch(watchyoutubevideosfunc(formData))
        }
    },[formData])

    return (
        <Fragment>
            <Breadcrumb   parent = "Dashboard" title = "Youtube-Videos" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <h5>{ListVideos}</h5>
                            </div>
                            <div className="card-body datatable-react">
                                <DataTable
                                    columns={data.columns}
                                    data={data.data}
                                    striped={true}
                                    center={true}
                                    highlightOnHover={true}
                                    persistTableHead
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default GetVideos;